import { RouteType } from 'types/RouteType';
// import FormatListNumberedIcon from '@mui/icons-material/RvHookup';

const loadListRoute: RouteType = {
  name: 'Load List',
  path: '/job/:jobNumber/load-list',
  layout: '/app',
  viewportCard: {
    header: {
      title: 'Load List',
      enableToolbox: true,
      enableBackButton: true,
      enableRefreshButton: true,
    },
    body: {
      // component: () => import('./LoadList.Body'),
      gridContainer: {
        namespace: 'LoadListDataGrid',
        storeName: 'loadListStore',
        customEntity: 'dataGridRows',
        // fixedRowCount: 2,
        columnHeaders: [
          {
            width: 150,
            title: 'CN',
            key: 'controlNumber',
            disableEdit: true,
            dataType: 'number',
          },
          {
            width: 190,
            title: 'Mark',
            key: 'markNumber',
            disableEdit: true,
          },
          {
            width: 190,
            title: 'Asm. Panel Weight',
            key: 'assembledPanelWeight',
            disableEdit: true,
          },
          {
            width: 190,
            title: 'Instl Sequence',
            key: 'installationSequence',
            disableEdit: true,
          },
          {
            width: 190,
            title: 'Load Number',
            key: 'loadNumber',
            disableEdit: true,
          },
          {
            width: 190,
            title: 'Yard Row',
            key: 'yardRow',
          },
          {
            width: 190,
            title: 'Yard Column',
            key: 'yardColumn',
          },
          {
            width: 190,
            title: 'Lvl Bolt Desc',
            key: 'levelingBoltDescription',
            disableEdit: true,
          },
        ],
        defaultSort: {
          sortBy: ['controlNumber'],
          sortDirection: { controlNumber: 'ASC' },
        },
        onRowClick: () => console.log('Clicked'),
        // onRowClick: ({ controlUUID }) =>
        // openDialog({
        //   dialogName: 'QR Code',
        //   dialogContext: controlUUID
        // })
      },
    },
  },
  group: 'Dispatch',
  requiresAuth: true, // Assuming requiresAuth is true since requiresPermission is true
  requiresPermission: false,
  permissionPath: '/app/load-list', // Using permissions array based on permissionPath
  channels: [
    'job/:jobNumber',
    'job/:jobNumber',
    'panel-revit/:jobNumber',
    'panel-plant/:jobNumber',
    'panel-yard/:jobNumber',
    'load/:jobNumber',
    'job-stats/panel-count/:jobNumber',
  ],
  enableAutoFind: true,
  projectRoute: true,
  // Note: 'hidden', 'noSection' and 'enableAutoFind' have no direct equivalents in the new RouteType.
  // You might need to handle these differently depending on their usage context.  For example,
  // 'hidden' could be implemented through conditional rendering logic based on permissions or feature flags.
  // 'noSection' and 'enableAutoFind' might require custom logic within the component itself.
};

export default loadListRoute;
